import React from 'react';
import { Modal } from '@chakra-ui/react';
const BaseModal = ({ isOpen, onClose, children, ...rest }) => {
    // Render
    return (<Modal isOpen={isOpen} onClose={onClose} isCentered {...rest}>
      {children}
    </Modal>);
};
export default BaseModal;
